<template lang="pug">
.c-the-home-chairmantalk
  chairman-box(:photo="chairmanPhoto"
    name="廖憲武"
    job="第十八屆理事長"
    homeland="高樹")
  .content.has-text-weight-medium.app-text
    p 創新與期許
      br
      br
      | 桃園市屏東同鄉會已邁入第十八屆，承蒙鄉親禮讓與器重由我來連任，已突破過往紀 錄(共三任)寫下歷史新徽章，繼續擔任第十八屆的同鄉會理事長一職，深感榮幸之至亦感 責任重大。⋯⋯
    div(:class="$style.readmore")
      span ⋯⋯
      b-button(type="is-warning"
        @click="readmore = true") 閱讀全文
  b-modal(:active.sync="readmore"
    animation="fade"
    has-modal-card
    full-screen)
    .modal-card
      .modal-card-body
        chairman-box(:photo="chairmanPhoto"
          name="廖憲武"
          job="第十八屆理事長"
          homeland="高樹")
        .content.has-text-weight-medium.app-text
        p 創新與期許
          br
          br
          | 桃園市屏東同鄉會已邁入第十八屆，承蒙鄉親禮讓與器重由我來連任，已突破過往紀 錄(共三任)寫下歷史新徽章，繼續擔任第十八屆的同鄉會理事長一職，深感榮幸之至亦感 責任重大。
          br
          br
          | 本會創會至今整體發展過程歷歷在目且充滿了許多共同美好的回憶，優質社團必須有 建全組織與制度來規範，同鄉會成員均北漂落地生根於桃園，個個滿懷希望與抱負並充滿鬥 志，從養家餬口、進入成家立業、再成為社會領導者持續成長。同鄉會裡臥虎藏龍，成員包 括軍公教、企業主、上班族、民意代表...等，由各行各業組成，性質多樣、流動快、建言多、 人來人往、組成本就不易，能夠延續至今，並保有輝煌功績。此成就需感謝歷任理事長汲汲 經營、承先啟後、帶領優良傳統才有今日的規模，更要感謝鄉親們共襄盛舉，真誠投入與付 出。畢竟守成不易，共同守護也是一種力量的展現。
          br
          br
          | 創會至今晃眼已近四十個年頭，號稱「不惑之年」實屬不易!但我們腳步不能停歇， 需更加穩健地向前走，攜手引領第二代甚至第三代從屏東北漂的年輕人加入，以灌助新血輪 活化組織、營造更健全、有榮譽感、有歡樂性、有期待性、有歸屬感的大家庭。
          br
          br
          | 在第十七屆任期中要感謝總幹事廖崑和、財務長趙月清的輔佐，也要感謝各分會主委 的積極配合，得以順利辦理並完成各項活動。爾後更需持續增進鄉親們之情感聯誼，並促進 鄉親各行業間的交流，創建「內部市場、共同消費」模式，藉以促進共同經濟發展，實質性 地互相提攜，達到「桃園市屏東同鄉會」成立之宗旨。
      .modal-card-foot
        b-button.app-m-auto(type="is-danger"
          outlined
          @click="readmore = false") 結束閱讀
</template>

<script>
import ChairmanBox from "@/components/ChairmanBox.vue";
import chairmanPhoto from "@/assets/images/17-1.png";

export default {
  name: "TheHomeChairmantalk",
  components: {
    ChairmanBox,
  },
  data() {
    return {
      chairmanPhoto,
      readmore: false,
    };
  },
};
</script>

<style module lang="sass">
.readmore
  +flexbox(flex-start, center)
  button
    margin: 0 pxRem(12)
</style>
